import { Container } from "./styles";

export function Divider(props: any){
    return(
        <Container>
            {props.children}
        </Container>
    )
}